import { useState } from 'react'
import client from '../utils/apollo-client'
import { Flex } from '@chakra-ui/react'
import { ProductContext } from '../store'
import {
  FilterSidebar,
  Sidebar,
  Headerbar,
  BaseLayout,
  ProductGallery,
  HtmlHead,
} from '../c'
//import { GET_INITAL_DATA } from '../gql'
import { CheckoutButton } from '../c/CheckoutButton'

export default function Home({ _products = [], brands = [] }) {
  //const [products, setProducts] = useState([..._products])
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient( #137468, #1cab91)',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '100vw',
        padding: '2rem',
      }}
    >
      <div
        style={{
          marginTop: '3rem',
          maxWidth: '800px',
          margin: '0 auto',
          padding: '2rem',
          background: '#ffffff',
          borderRadius: '1rem',
          boxShadow: '0 0 10px 0 #0000005c',
        }}
      >
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '2rem',
          }}
        >
          Farva.fo hevur steðgað
        </h1>
        <p>
          Farva.fo hevur steðgað virkseminum, og vit taka ikki longur ímóti
          bíleggingum.
        </p>
        <p
          style={{
            marginTop: '1rem',
            fontWeight: 'bold',
          }}
        >
          Vit takka hjartaliga øllum fyri handilin!
        </p>
      </div>
    </div>
  )
  return (
    <>
      <HtmlHead />
      <ProductContext.Provider value={[products, setProducts]}>
        <BaseLayout>
          <Headerbar withSearch />
          <Flex minW='100%' grow='1' direction={['column', 'row']}>
            <Sidebar>
              <FilterSidebar brands={brands} />
            </Sidebar>
            <Flex
              as='main'
              pl={{ md: 10, sm: 0 }}
              grow='1'
              bg='white'
              align='start'
              pos='relative'
              pb={12}
            >
              <ProductGallery initProducts={[..._products]} />
              <CheckoutButton />
            </Flex>
          </Flex>
        </BaseLayout>
      </ProductContext.Provider>
    </>
  )
}

// export async function getServerSideProps() {
//   const { data } = await client.query({
//     query: GET_INITAL_DATA,
//   })

//   return {
//     props: {
//       brands: data.printer_brands || [],
//       _products: data.products || [],
//     },
//   }
// }
